import {ru} from './ru'

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

const iterate = (obj) => {
  Object.keys(obj).forEach(key => {
    // console.log('key: ' + key + ', value: ' + obj[key])
    if (typeof obj[key] === 'object') {
      iterate(obj[key])
    } else {
      let split = capitalizeFirstLetter(key).match(/[A-Z][a-z]+|[0-9]+/g)
      if (split) {
        for (let i = 0; i < split.length; i++) {
          if (i > 0) {
            split[i] = split[i].toLowerCase()
          }
        }
        obj[key] = split.join(' ')
      } else {
        obj[key] = capitalizeFirstLetter(key)
      }
    }
  })
}

function isObject(obj) {
  var type = typeof obj
  return type === 'function' || (type === 'object' && !!obj)
}
function iterationCopy(src) {
  let target = {}
  for (let prop in src) {
    if (src.hasOwnProperty(prop)) {
      // if the value is a nested object, recursively copy all it's properties
      if (isObject(src[prop])) {
        target[prop] = iterationCopy(src[prop])
      } else {
        target[prop] = src[prop]
      }
    }
  }
  return target
}

export function generateEnByRu() {
  // let ruToEn = Object.assign({}, JSON.parse(JSON.stringify(ru))) // copy
  let ruToEn = iterationCopy(ru) // copy
  iterate(ruToEn)
  return ruToEn
}




// WEBPACK FOOTER //
// ./client/translations/enAutoGenerate.js